import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

export const getSettingsStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      paddingHorizontal: theme.spacing.lg,
      paddingTop: theme.spacing.lg,
    },
    contentContainer: {
      paddingBottom: theme.spacing.xl,
    },
    sectionTitle: {
      marginBottom: theme.spacing.xs,
    },
    sectionDescription: {
      color: theme.colors.secondary,
      marginBottom: theme.spacing.lg,
    },
    optionsContainer: {
      gap: theme.spacing.sm,
    },
    optionCard: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingVertical: theme.spacing.md,
      paddingHorizontal: theme.spacing.lg,
      borderRadius: 12,
      borderWidth: 1,
      borderColor: theme.colors.grey20 ?? theme.colors.lightGrey,
      backgroundColor: theme.colors.white,
    },
    optionCardSelected: {
      borderColor: theme.colors.primary,
      backgroundColor: theme.colors.primary + '10',
    },
    optionText: {
      color: theme.colors.text ?? '#000',
    },
    optionTextSelected: {
      color: theme.colors.primary,
      fontWeight: '600',
    },
    locationLabel: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing.md,
      flex: 1,
      marginRight: theme.spacing.md,
    },
    locationTextBlock: {
      flex: 1,
    },
    // Web-friendly on/off toggle (the native RN Switch renders glitchy on web).
    toggleTrack: {
      width: 48,
      height: 28,
      borderRadius: 14,
      backgroundColor: theme.colors.grey20 ?? theme.colors.lightGrey,
      paddingHorizontal: 3,
      justifyContent: 'center',
    },
    toggleTrackOn: {
      backgroundColor: theme.colors.primary,
    },
    toggleThumb: {
      width: 22,
      height: 22,
      borderRadius: 11,
      backgroundColor: theme.colors.white,
      alignSelf: 'flex-start',
      shadowColor: '#000',
      shadowOpacity: 0.2,
      shadowRadius: 2,
      shadowOffset: { width: 0, height: 1 },
      elevation: 2,
    },
    toggleThumbOn: {
      alignSelf: 'flex-end',
    },
  })
